export enum ChargebackIssueType {
    AsnAccuracy = "ASN Accuracy",
    CartonContentAccuracy = "Carton Content Accuracy",
    CartonInformationCompliance = "Carton Information Compliance",
    OversizedCarton = "Oversized Carton",
    OverweightCarton = "Overweight Carton",
    POOnTimeAccuracy = "PO On-Time Accuracy",
    PrepBagging = "Prep - Bagging",
    PrepBoxing = "Prep - Boxing",
    PrepBubbleWrapping = "Prep - Bubble wrapping",
    PrepTaping = "Prep - Taping",
    ShipInOwnContainer = "Ship In Own Container",
}

export const chargebackIssueTypeList = [
    { value: ChargebackIssueType.AsnAccuracy, label: "ASN Accuracy" },
    { value: ChargebackIssueType.CartonContentAccuracy, label: "Carton Content Accuracy" },
    { value: ChargebackIssueType.CartonInformationCompliance, label: "Carton Information Compliance" },
    { value: ChargebackIssueType.OversizedCarton, label: "Oversized Carton" },
    { value: ChargebackIssueType.OverweightCarton, label: "Overweight Carton" },
    { value: ChargebackIssueType.POOnTimeAccuracy, label: "PO On-Time Accuracy" },
    { value: ChargebackIssueType.PrepBagging, label: "Product preparation - Bagging" },
    { value: ChargebackIssueType.PrepBoxing, label: "Product preparation - Boxing" },
    { value: ChargebackIssueType.PrepBubbleWrapping, label: "Product preparation - Bubble wrapping" },
    { value: ChargebackIssueType.PrepTaping, label: "Product preparation - Taping" },
    { value: ChargebackIssueType.ShipInOwnContainer, label: "Ship In Own Container" },
];

